import RendererTypesEnum from "./RendererTypesEnum";
import config, { FilterTypeEnum } from "./config";
const getFilterConfig = (filter) => {
  var _a;
  const defaultCfg = {
    attribute_code: filter.attribute_code,
    frontend_input: filter.frontend_input,
    type: FilterTypeEnum.CHECKBOX,
    component: RendererTypesEnum.CHECKBOX,
    disabled: false
  };
  const find = (_a = config().find((cfgItem) => cfgItem.frontend_input === filter.frontend_input)) != null ? _a : {};
  return { ...defaultCfg, ...find };
};
const getDisabledFilters = () => config().filter((filter) => filter.disabled).map((filter) => filter.attrCode);
const isFilterEnabled = (attrCode) => config().find((attr) => attr.attrCode === attrCode && !attr.disabled);
export {
  getDisabledFilters,
  getFilterConfig,
  isFilterEnabled
};
